import React, { useEffect, useState } from 'react';
import icon from '../../_assets/img/folder.png';
import api from '../../_helpers/Request/api';
import { useHistory } from 'react-router-dom';
import notify from 'devextreme/ui/notify';
import Aggrement from '../Steps/Aggrement';

const FromFille = () => {
    const fileInputRef = React.createRef<any>();
    const history = useHistory();
    const [agreement, setAgreement] = useState<boolean | undefined>(undefined);
    const [eeee, setEeee] = useState<any>(null);

    const answer = async (e: any) => {
        e.preventDefault();
        setAgreement(false);
    };

    const showFile = async (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        localStorage.removeItem('agreement');
        if (e.target.value.match(/\.([^\.]+)$/)[1] === 'prof') {
            const reader = new FileReader();

            localStorage.setItem('type', 'fromFile');
            reader.onload = async (e) => {
                const text = e.target!.result;
                let param = {
                    content: text
                };

                try {
                    const { data } = await api.post<string>('File/Decrypted', param);
                    console.log(data, 'data');
                    const localStorageData = (await JSON.parse(new Buffer(data, 'base64').toString('utf8'))) as [];

                    localStorageData.map((item) => {
                        if (item['step1']) {
                            localStorage.setItem('step1', item['step1']);
                        }
                        if (item['step2']) {
                            localStorage.setItem('step2', item['step2']);
                        }
                        if (item['step3']) {
                            localStorage.setItem('step3', item['step3']);
                        }
                        if (item['step4']) {
                            localStorage.setItem('step4', item['step4']);
                        }
                        if (item['payment']) {
                            localStorage.setItem('payment', item['payment']);
                        }
                        if (item['stepManager']) {
                            localStorage.setItem('stepManager', item['stepManager']);
                        }
                        if (item['step44']) {
                            localStorage.setItem('step44', item['step44']);
                        }
                        if (item['step45']) {
                            localStorage.setItem('step45', item['step45']);
                        }
                        if (item['largeFamily']) {
                            localStorage.setItem('largeFamily', item['largeFamily']);
                        }
                        if (item['D1']) {
                            localStorage.setItem('D1', item['D1']);
                        }
                        if (item['TypeOfActivitySection']) {
                            localStorage.setItem('TypeOfActivitySection', item['TypeOfActivitySection']);
                        }
                    });
                } catch (err) {
                    notify('Wczytywanie pliku nie powiodło się', 'error', 3000);
                }

                history.push({
                    pathname: '/step1',
                    state: { new: false, fromLocalStorage: true }
                });
            };
            reader.readAsText(e.target.files[0]);
        } else {
            notify('Zły format pliku, musi być nazwa.prof', 'error', 3000);
        }
        setEeee(null);
    };
    //fileInputRef.current.click();
    //fileInputRef.current.click();
    return (
        <>
            <div className="col-12">
                <div
                    className="card option"
                    id="fromFilecard"
                    role="button"
                    typeof="button"
                    onKeyPress={(e) => {
                        if (e?.charCode === 13) {
                            fileInputRef.current.click();
                        }
                    }}
                    aria-pressed="false"
                    tabIndex={0}
                    onClick={(e) => {
                        setEeee(e);
                        fileInputRef.current.click();
                    }} //answer(e)
                >
                    <div className="row">
                        <div className="col-2 d-flex justify-content-around imgCard imgCardL">
                            <img src={icon} alt="Po wybraniu pliku z dysku komputera, zostaną uzupełnione dane w kreatorze deklaracji" />
                        </div>
                        <div className="col-10 imgCardR">
                            <input
                                id="fromFile"
                                aria-required="true"
                                aria-describedby="fromFile"
                                className="inputVisible"
                                type="file"
                                accept=".prof"
                                onChange={(e) => {
                                    showFile(e);
                                }}
                                ref={fileInputRef}
                            />
                            <div className="secendaryHeader">
                                <label htmlFor="fromFile" onClick={(e) => e.preventDefault()}>
                                    <div className="TitleCategory">Wczytaj deklarację z pliku</div>
                                </label>
                            </div>
                            <p className="card-text">Wczytaj deklarację a kreator uzupełni pola, które już zostały wcześniej uzupełnione.</p>
                        </div>
                    </div>
                </div>
            </div>
            {!agreement ? <Aggrement agreement={agreement ?? true} setAgreement={setAgreement} /> : null}
        </>
    );
};

export { FromFille };
